import type { AreaOfResponsibility } from '../../../../../types/aor';

/** Roster `home_aor` may be stored as AOR `id` or `item_id`. */
export function findAorByHomeId(
  aors: AreaOfResponsibility[] | undefined,
  homeAorId: string | null | undefined
): AreaOfResponsibility | undefined {
  if (!aors || !homeAorId) return undefined;
  return aors.find(
    (aor) => aor.id === homeAorId || aor.item_id === homeAorId
  );
}
